<template>
  <div class="lg-table-container">
    <h5>{{ title }}</h5>

    <div class="p-fluid p-grid p-align-end p-mb-2">
      <div class="p-field p-col">
        <label>Código</label>
        <InputText v-model="newItem.code" type="text" />
      </div>
      <div class="p-field p-col">
        <label>Descrição</label>
        <InputText v-model="newItem.description" type="text" />
      </div>
      <div class="p-field p-col-fixed" style="width: 100px">
        <Button icon="pi pi-plus" class="p-button-primary" @click="addItem" :disabled="!newItem.code || saving" :loading="saving" />
      </div>
    </div>

    <DataTable :value="value" class="p-datatable-sm p-datatable-gridlines" :rows="5" :paginator="true">
      <Column field="code" header="Código"></Column>
      <Column field="description" header="Descrição"></Column>
      <Column header="Ações" headerStyle="width: 5rem" bodyStyle="text-align: center">
        <template #body="slotProps">
          <Button icon="pi pi-trash" class="p-button-danger p-button-text" @click="removeItem(slotProps.index)" />
        </template>
      </Column>
      <template #empty>
        Nenhum código configurado.
      </template>
    </DataTable>
  </div>
</template>

<script>
export default {
  name: 'LgTableConfigCodes',
  props: {
    code: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      newItem: {
        code: '',
        description: ''
      }
    };
  },
  computed: {
    title() {
      const titles = {
        symptom: 'Sintomas',
        symptom2: 'Sintomas Secundários',
        defect: 'Defeitos',
        primary_repair_code: 'Reparo Primário',
        repair_level_code: 'Nível de Reparo'
      };
      return titles[this.code] || this.code;
    }
  },
  methods: {
    addItem() {
      const codeExists = this.value.some(item =>
          item.code.toLowerCase() === this.newItem.code.toLowerCase()
      );

      if (codeExists) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Este código já existe nesta lista.'
          });
          return;
      }

      if (this.newItem.code.trim()) {
          const updatedList = [...this.value, { ...this.newItem, id: null }];
          this.newItem.code = '';
          this.newItem.description = '';
          this.$emit('input', updatedList);
          this.$emit('save');
      }
    },
    removeItem(index) {
      const updatedList = [...this.value];
      updatedList.splice(index, 1);

      this.$emit('input', updatedList);
      this.$emit('save');
    }
  }
};
</script>

<style scoped>
.lg-table-container {
  border: 1px solid #dee2e6;
  padding: 1rem;
  border-radius: 4px;
  background: #f8f9fa;
}
h5 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #495057;
  text-transform: uppercase;
  font-size: 0.9rem;
}
</style>